import { httpClient } from '@/shared/api/httpClient';
import { ReferenceData } from '@/shared/types/certificate-request';

export const referenceDataApi = {
  async load(): Promise<ReferenceData> {
    const { data } = await httpClient.get<ReferenceData>('/reference-data');
    return data;
  },
};
